import React from 'react';
import { InboxOutlined } from '@ant-design/icons';

// Shared empty-state for the CRM report tabs. Centered vertically + horizontally
// in whatever box it sits in, with an icon above the message.
export default function CrmEmpty({ text = "موردی یافت نشد" }) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 12,
                minHeight: 320,
                width: '100%',
                textAlign: 'center',
                color: 'rgba(0, 0, 0, 0.45)',
            }}
        >
            <InboxOutlined style={{ fontSize: 52, color: 'rgba(0, 0, 0, 0.18)' }} />
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>{text}</div>
        </div>
    );
}
